import { render, staticRenderFns } from "./userSupport.vue?vue&type=template&id=54b783b2&scoped=true"
import script from "./userSupport.vue?vue&type=script&lang=js"
export * from "./userSupport.vue?vue&type=script&lang=js"
import style0 from "./userSupport.vue?vue&type=style&index=0&id=54b783b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b783b2",
  null
  
)

export default component.exports